// Import products from JSON file
import productsData from '../../products.json';

// Export the products array directly from JSON
export const dentalProducts = productsData;

// Extract unique categories from products
const uniqueCategories = [...new Set(productsData.map(p => p.category))].sort();

export const productCategories = uniqueCategories.map((category, index) => ({
  id: index + 1,
  name: category,
  description: `${category} products for dental professionals`,
  subcategories: [...new Set(productsData.filter(p => p.category === category).map(p => p.subcategory))],
  image_url: `https://via.placeholder.com/300x200?text=${encodeURIComponent(category)}`,
  count: productsData.filter(p => p.category === category).length
}));

// Category grouping for smart navigation
export const categoryGroups = {
  "Equipment": [
    "EQUIPMENT", "AIROTOR", "CONTRA ANGLE HAND PIECE", "STRAIGHT HAND PIECE", 
    "ENDOMOTOR", "RVG", "DISPENSING GUN"
  ],
  "Instruments": [
    "INSTRUMENT", "BURS", "ENDODONTICS", "ORTHODONTICS", "ORAL SURGERY", 
    "PERIODONTICS", "PROSTHODONTICS", "FILLING INSTRUMENT", 
    "COMPOSITE FILLING INSTRUMENT", "HAND FILES", "ROTARY FILES", 
    "GP CUTTER", "HEMOSTAT", "IMPLANTOLOGY"
  ],
  "Materials": [
    "BONDING AGENT", "COMPOSITE FILLING MATERIALS", "GIC", "CALCIUM HYDROXIDE", 
    "MTA", "BIODENTINE", "IMPRESSION MATERIAL", "TEMPORARY CEMENT", 
    "TEMPORARY CROWN AND BRIDGE MATERIAL", "ROOT CANAL SEALER", "RCT CHEMICALS",
    "ETCHANT", "FIBER POST", "FIBER SPLINT", "METAL POST", "CORE BUILD UP MATERIAL",
    "GUTTA PERCHA GP", "BLEACHING KIT", "FLUORIDE", "PROPHYLAXIS PASTE",
    "PULP DEVITALIZER", "WAX", "SILANE"
  ]
};

// Function to get all categories in a group
export const getCategoriesByGroup = (groupName) => {
  return categoryGroups[groupName] || [];
};

// Featured products - products with higher discounts
export const featuredProducts = dentalProducts.filter(product => {
  const discountPercentage = parseInt(product.discount?.replace(/[()%OFF\s]/g, '') || '0');
  return discountPercentage >= 40; // Products with 40% or more discount
}).slice(0, 12); // Limit to 12 featured products

// Products by category
export const getProductsByCategory = (category) => {
  if (category === "all") return dentalProducts;
  return dentalProducts.filter(product => product.category === category);
};

// Search products
export const searchProducts = (query) => {
  const searchTerm = query.toLowerCase();
  return dentalProducts.filter(product => 
    product.name.toLowerCase().includes(searchTerm) ||
    product.description.toLowerCase().includes(searchTerm) ||
    product.brand.toLowerCase().includes(searchTerm) ||
    product.category.toLowerCase().includes(searchTerm) ||
    product.subcategory.toLowerCase().includes(searchTerm)
  );
};

export default dentalProducts;
